import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { fundmanagerapi } from "../../ApiNames";
type Nullable<T> = T | null;

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data,
});
export const fetchDataViewSuccess = (viewdocdata:any)=>({
    type : 'FETCH_VIEWDOC_DATA_SUCCESS',
    payload:viewdocdata,
});
export const fetchMsgDataSuccess = (chatdata: any) => ({
    type: 'VIEW_DATA_SUCCESS',
    payload: chatdata,
});

export const fetchMsgViewDataSuccess = (successdata: any) => ({
    type: 'FETCH_DATA_SUCCESS_MAS',
    payload: successdata,
});
export const ApproveDataSuccess = (approvedata: any) => ({
    type: 'Approve_DATA_SUCCESS',
    payload: approvedata,
});
export const RejectDataSuccess = (rejectdata: any) => ({
    type: 'Reject_DATA_SUCCESS',
    payload: rejectdata,
});


export const fetchdata = (application_id:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {need:application_id,Userid:uid};
            const apiname = fundmanagerapi.viewapplication;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchviewdata = (application_id:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {need:application_id,q:14};
            const apiname = fundmanagerapi.approvedata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const messageData = (uid:any,usertype:any,application_id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,usertype:usertype,need:application_id };
            const apiname = fundmanagerapi.orgapplication;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchMsgDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const sendmsgdata = (uid:any,message:any,application_id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,message:message,need:application_id,q:1 };
            const apiname = fundmanagerapi.messagetype;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchMsgViewDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const ApproveData = ( application_id:any,edate:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { need:application_id,edate:edate,q:8};
            const apiname = fundmanagerapi.approvedata;
            const response = await LoginService.getData(apiname,payload)
            dispatch(ApproveDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const RejectData = ( application_id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { need:application_id,q:9};
            const apiname = fundmanagerapi.approvedata;
            const response = await LoginService.getData(apiname,payload)
            dispatch(RejectDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

